// Frontend copy of lib/addressMatch.js (kept in sync by hand — CRA's ModuleScopePlugin blocks
// importing files from outside src/, so this can't just be shared directly with the server).
// Deliberately simple, dependency-free address matching: street-number-plus-street-word
// heuristics, good enough to tell two different addresses apart without needing them formatted
// identically (one side here is Nominatim's reverse-geocoded display_name, the other is however
// staff typed a client's address).
function normalizeAddress(value) {
  return (value || '')
    .toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function addressTokens(value) {
  return normalizeAddress(value).split(' ').filter(Boolean);
}

export function fuzzyAddressMatch(a, b) {
  const tokensA = addressTokens(a);
  const tokensB = addressTokens(b);
  if (tokensA.length === 0 || tokensB.length === 0) return false;

  const numA = /^\d+$/.test(tokensA[0]) ? tokensA[0] : null;
  const numB = /^\d+$/.test(tokensB[0]) ? tokensB[0] : null;

  if (numA && numB) {
    if (numA !== numB) return false;
    const restA = new Set(tokensA.slice(1).filter((w) => w.length >= 4));
    const restB = tokensB.slice(1).filter((w) => w.length >= 4);
    return restB.some((w) => restA.has(w));
  }

  const setA = new Set(tokensA);
  const setB = new Set(tokensB);
  const shared = [...setA].filter((w) => setB.has(w)).length;
  const union = new Set([...tokensA, ...tokensB]).size;
  return union > 0 && shared / union >= 0.5;
}
